import type { EndpointMeta } from "@/apis/types";
import {
  createFetchAndHook,
  type FetchFactory,
  type HookFactory,
} from "@/shared/factories";
import { wsdotWeatherInformationApiMeta } from "../apiMeta";
import {
  type WeatherInformationInput,
  weatherInformationInputSchema,
} from "./shared/weatherInfo.input";
import {
  type WeatherInfo,
  weatherInfoSchema,
} from "./shared/weatherInfo.output";

/**
 * Metadata for the fetchWeatherInformation endpoint
 */
export const weatherInformationMeta = {
  functionName: "fetchWeatherInformation",
  endpoint: "/GetCurrentWeatherInformationAsJson",
  inputSchema: weatherInformationInputSchema,
  outputSchema: weatherInfoSchema.array(),
  sampleParams: {},
  endpointDescription: "List current weather information for all stations.",
} satisfies EndpointMeta<WeatherInformationInput, WeatherInfo[]>;

/**
 * Fetch function for retrieving current weather information for all stations
 */
const { fetch, useHook } = createFetchAndHook<
  WeatherInformationInput,
  WeatherInfo[]
>({
  api: wsdotWeatherInformationApiMeta,
  endpoint: weatherInformationMeta,
  getCacheStrategy: () =>
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    require("./shared/weatherInfo.endpoints").weatherInfoGroup.cacheStrategy,
});

/**
 * Fetch function for retrieving current weather information for all stations
 */
export const fetchWeatherInformation: FetchFactory<
  WeatherInformationInput,
  WeatherInfo[]
> = fetch;

/**
 * React Query hook for retrieving current weather information for all stations
 */
export const useWeatherInformation: HookFactory<
  WeatherInformationInput,
  WeatherInfo[]
> = useHook;
